<footer [ngSwitch]="type" fxLayout="column" fxLayoutAlign="start start">
    <post-files *ngSwitchCase="FooterType.File" [post]="post"></post-files>
    <post-comments [forTask]="forTask" class="full-width" *ngSwitchDefault [post]="post"></post-comments>
</footer>
